import { Stack, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

import { CountryCell } from "~/components/cells/CountryCell.tsx"
import { FindCertificatesByOrganizationIdResponseDto } from "~/gen/api"

type Props = {
  certificate: FindCertificatesByOrganizationIdResponseDto
}

export function CertificateProductionSite({ certificate }: Props) {
  const { t } = useTranslation("admin")
  if (!certificate.productionSite) return null
  return (
    <Stack gap={0}>
      <Text>{t("certificates.modal.labels.productionSite")}</Text>
      <Stack gap={0}>
        <Text fw="bold">{certificate.productionSite.name}</Text>
        <Stack c="gray" gap={0}>
          <Text fz="10px" fs="italic">
            {certificate.productionSite.address}
          </Text>
          <CountryCell
            countryIso3166={certificate.productionSite.countryIso3166}
          />
        </Stack>
      </Stack>
    </Stack>
  )
}
